import type { Asset } from "schemas/generated/asset";

import * as React from "react";

import { Spinner } from "@replo/design-system/components/spinner/Spinner";

import { AssetPreview } from "./AssetPreview";

export const AssetThumbnail: React.FC<{
  asset: Asset;
  isUploading?: boolean;
}> = ({ asset, isUploading }) => {
  return (
    <div className="relative aspect-square overflow-hidden rounded-sm">
      <AssetPreview asset={asset} isUploading={isUploading} />
      {isUploading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/30">
          <Spinner className="size-6" variant="white" />
        </div>
      )}
    </div>
  );
};
